import { Button, Tooltip } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

import { useAppState } from '../context/LoadTestContext';

// The header bar's button for the Calibration window, where a test's
// calibration revisions are edited, previewed and applied and the display units
// are picked. The window itself is CalibrationHost, mounted once for the page:
// this button is rebuilt when the header switches between its desktop and phone
// layouts, and the window (and any unsaved edits) must not go with it.
function CalibrationControl() {
  const { loadTest, calPreview, setCalDialogOpen } = useAppState();

  const revNumber = loadTest?.revision?.rev_number;
  const tooltip = calPreview
    ? 'A calibration preview is showing'
    : revNumber != null ? `Calibration and units. Rev ${revNumber} is in use.` : 'Calibration and units';

  return (
    <Tooltip title={tooltip} arrow>
      <Button
        variant='outlined'
        size='small'
        color={calPreview ? 'warning' : 'primary'}
        startIcon={<TuneIcon fontSize='small' />}
        // Inside a collapsible card's header on phones: don't fold the card.
        onClick={(e) => { e.stopPropagation(); setCalDialogOpen(true); }}
        sx={{ flexShrink: 0, py: 0.25, px: 1, fontSize: 12, textTransform: 'none', whiteSpace: 'nowrap' }}
      >
        Calibration
      </Button>
    </Tooltip>
  );
}

export default CalibrationControl;
